import { Directive, Input, Output, EventEmitter, OnInit, OnDestroy, HostListener, ElementRef } from '@angular/core';
import { Subscription, Subject, debounceTime } from 'rxjs';
import { throttleTime } from 'rxjs';

/**
 * @deprecated
 * unnecessary
 */
@Directive({
  selector: '[hostThrottleClick]',
})
export class ThrottleClickDirective implements OnInit, OnDestroy {
  @Input() throttleTime = 1000;
  @Output() throttleClick = new EventEmitter();
  private click$ = new Subject<void>();
  private subscription: Subscription;

  constructor(private el: ElementRef) {}

  ngOnInit() {
    this.subscription = this.click$.pipe(throttleTime(this.throttleTime)).subscribe(() => {
      this.throttleClick.emit();
    });

    // this.subscription = this.click$.pipe(throttleTime(this.throttleTime)).subscribe((e) => this.throttleClick.emit(e));
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  @HostListener('click', ['$event'])
  clickEvent(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.click$.next();
  }
}
